<template>
  <div id="application-list">
    <v-card>
      <div class="pa-5">
        <v-row class="align-sm-center">
          <v-col cols="12">
            <v-card-title class="pa-0">Applications List</v-card-title>
          </v-col>
        </v-row>
      </div>

      <v-divider />

      <v-card-text>
        <v-row dense>
          <!-- search -->
          <v-col cols="12" sm="8" md="6" lg="4">
            <v-text-field
              v-model="searchQuery"
              placeholder="Search"
              outlined
              hide-details
              dense
              class="application-search-query application-search"
            />
          </v-col>

          <v-col cols="12" sm="4" md="3" lg="2">
            <v-dialog ref="dialog" v-model="applicationDateModal" :return-value.sync="applicationDateFilter" width="290px">
              <template #activator="{ on, attrs }">
                <v-text-field
                  v-model="applicationDateFilter"
                  class="application-date-filter"
                  label="Date"
                  outlined
                  dense
                  clearable
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="applicationDateFilter" class="event-date-picker" scrollable range>
                <v-row style="text-align: end">
                  <v-col cols="12">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="$refs.dialog.save(applicationDateFilter = null)"> Cancel </v-btn>
                    <v-btn text color="primary" @click="$refs.dialog.save(applicationDateFilter)"> OK </v-btn>
                  </v-col>
                </v-row>
              </v-date-picker>
            </v-dialog>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- table -->
      <v-data-table
        :options.sync="options"
        :headers="tableColumns"
        :items="applicationListTable"
        :item-class="applicationItemClass"
        :server-items-length="totalApplicationListTable"
        :loading="loading"
      >
        <!-- date -->
        <template #[`item.createdAt`]="{ item }">
          <div class="application-created-at">{{ item.createdAt | dayjs('YYYY-MM-DD HH:mm:ss') }}</div>
        </template>

        <!-- name -->
        <template #[`item.name`]="{ item }">
          <p class="text--ellipsis ma-0">{{ item.name }}</p>
        </template>

        <!-- email -->
        <template #[`item.email`]="{ item }">
          <p class="text--ellipsis ma-0">{{ item.email }}</p>
        </template>

        <!-- phone -->
        <template #[`item.number`]="{ item }">
          <p class="text--ellipsis ma-0">{{ item.number }}</p>
        </template>

        <!-- website -->
        <template #[`item.website`]="{ item }">
          <p class="text--ellipsis ma-0">{{ item.website }}</p>
        </template>

        <!-- companyName -->
        <template #[`item.companyName`]="{ item }">
          <p class="text--ellipsis ma-0">{{ item.companyName }}</p>
        </template>

        <!-- actions -->
        <template #[`item.actions`]="{ item }">
          <v-menu bottom left>
            <template #activator="{ on, attrs }">
              <v-btn class="admin-list-item-show-more-actions" icon v-bind="attrs" v-on="on">
                <v-icon>{{ icons.mdiDotsVertical }}</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item class="admin-list-item-detail" :to="{ name: 'applications-view', params: { id: item.id } }">
                <v-list-item-title>
                  <v-icon size="20" class="me-2">
                    {{ icons.mdiFileDocumentOutline }}
                  </v-icon>
                  <span>Details</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item class="admin-list-item-delete" @click="deleteApplication(item)">
                <v-list-item-title>
                  <v-icon size="20" class="me-2">
                    {{ icons.mdiDeleteOutline }}
                  </v-icon>
                  <span>Delete</span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mdiDotsVertical, mdiFileDocumentOutline, mdiDeleteOutline } from '@mdi/js';
import store from '@/store';
import Vue from 'vue';
import useApplicationsList from '@/views/applications/useApplicationsList';

export default {
  setup() {
    const {
      applicationDateFilter,
      applicationDateModal,
      applicationListTable,
      tableColumns,
      searchQuery,
      loading,
      options,
      totalApplicationListTable,
      fetchApplications,
    } = useApplicationsList();

    const deleteApplication = application => {
      Vue.$confirm({
        message: `Are you sure you want to delete ${application.name}?`,
        button: {
          no: 'No',
          yes: 'Yes',
        },
        callback: confirm => {
          if (confirm) {
            store
              .dispatch('application/deleteApplication', { id: application.id })
              .then(() => fetchApplications())
              .catch(() => {
                Vue.notify({
                  type: 'error',
                  title: 'Application',
                  text: 'Cannot delete application',
                });
              });
          }
        },
      });
    };

    const applicationItemClass = () => {
      return 'application-item';
    };

    return {
      applicationDateFilter,
      applicationDateModal,
      applicationListTable,
      tableColumns,
      searchQuery,
      totalApplicationListTable,
      loading,
      options,
      fetchApplications,
      deleteApplication,
      applicationItemClass,
      icons: {
        mdiFileDocumentOutline,
        mdiDotsVertical,
        mdiDeleteOutline,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.application-created-at {
  min-width: 10rem;
}

.application-date-filter {
  ::v-deep .v-input__control > .v-input__slot {
    background: transparent !important;
  }
  ::v-deep .v-label {
    font-size: 14px;
    color: rgba(94, 86, 105, 0.38);
    &.theme--dark {
      color: rgba(231, 227, 252, 0.5)
    }
  }
}
</style>
